/**
 Project	IAM - Validation

 @file 	    admin-org.model.ts
 @author  	Pol Sabido <martin.tazlari@ictvs.ch>
 @copyright © 2024, ICT-vs. All rights reserved.
 **/

export interface UserSettings {
  defaultGE: string;
  displayModeId: number;
}

export const DISPLAYMODE = {
  Maxi: 0,
  Mini: 1,
  List: 2,
} as const;
